import axios from '@/api/axios'

export default {
    updateStatus: ({ status, id }) =>
        axios
            .put(`/base/api/wig/${id}/updateStatus`, { ...status })
            .then((res) => res.data),
}
